export default __webpack_public_path__ + "static/contract-d342cfed6b1e0a5d90a73d8523fd1328.jpg";